(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collection-description"] && !Shopify.designMode) return;
  try {
    class CollectionDescription extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('[data-content]');
      this.toggle = this.querySelector('[data-toggle]');
      this.expanded = false;
      this.needsTruncation = false;
    }

    connectedCallback() {
      this.checkTruncation();
      this.setupToggle();

      // Re-check on resize
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => {
          if (!this.expanded) {
            this.checkTruncation();
          }
        });
        this.resizeObserver.observe(this.content);
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    checkTruncation() {
      if (!this.content || !this.toggle) return;

      // Temporarily expand to measure full height
      const wasCollapsed = this.content.classList.contains('collection-description__content--collapsed');
      this.content.classList.remove('collection-description__content--collapsed');

      const fullHeight = this.content.scrollHeight;

      // Apply collapsed state
      this.content.classList.add('collection-description__content--collapsed');
      const collapsedHeight = this.content.clientHeight;

      // Check if content exceeds the collapsed height
      this.needsTruncation = fullHeight > collapsedHeight + 5; // 5px tolerance

      if (this.needsTruncation) {
        this.toggle.style.display = '';
        this.classList.add('collection-description--truncatable');
        if (!wasCollapsed || !this.expanded) {
          this.content.classList.add('collection-description__content--collapsed');
        }
      } else {
        this.toggle.style.display = 'none';
        this.classList.remove('collection-description--truncatable');
        this.content.classList.remove('collection-description__content--collapsed');
      }
    }

    setupToggle() {
      if (!this.toggle) return;

      this.toggle.addEventListener('click', () => {
        this.expanded = !this.expanded;
        this.toggle.setAttribute('aria-expanded', this.expanded.toString());

        if (this.expanded) {
          this.content.classList.remove('collection-description__content--collapsed');
          this.classList.add('collection-description--expanded');
        } else {
          this.content.classList.add('collection-description__content--collapsed');
          this.classList.remove('collection-description--expanded');
        }
      });
    }
  }

  if (!customElements.get('collection-description')) {
    customElements.define('collection-description', CollectionDescription);
  }
  } catch(e) { console.error(e); }
})();

})();
